import { Languages } from "lucide-react";
import { useLang } from "@/lib/i18n";

const LANGS = [["fr", "FR"], ["en", "EN"], ["ar", "ع"], ["ur", "اردو"], ["hi", "हिं"], ["tl", "TL"]];

export default function LanguageSwitcher({ dark = false }) {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="language-switcher"
      className={`inline-flex items-center gap-0.5 rounded-full p-1 ${dark ? "bg-white/10" : "border border-slate-200 bg-white"}`}
    >
      <Languages className={`mx-1 hidden h-4 w-4 sm:block ${dark ? "text-white/60" : "text-slate-400"}`} />
      {LANGS.map(([code, label]) => (
        <button
          key={code}
          type="button"
          data-testid={`lang-${code}-btn`}
          onClick={() => setLang(code)}
          className={`rounded-full px-2 py-1 text-xs font-bold transition-colors ${
            lang === code ? "bg-[#007A3D] text-white" : dark ? "text-white/70 hover:bg-white/10" : "text-slate-600 hover:bg-slate-100"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
